import React, { createContext, useContext, useEffect, useState } from 'react';

const ApiKeyContext = createContext();
const STORAGE_KEY = 'medexplain_openai_api_key';

export const useApiKey = () => {
  const context = useContext(ApiKeyContext);

  if (!context) {
    throw new Error('useApiKey must be used within an ApiKeyProvider');
  }

  return context;
};

export const ApiKeyProvider = ({ children }) => {
  const [apiKey, setApiKey] = useState('');

  useEffect(() => {
    try {
      const savedKey = sessionStorage.getItem(STORAGE_KEY);
      localStorage.removeItem(STORAGE_KEY);

      if (savedKey) {
        setApiKey(savedKey);
      }
    } catch (error) {
      console.warn('Unable to restore the API key for this session:', error);
    }
  }, []);

  const updateApiKey = (key) => {
    const normalizedKey = typeof key === 'string' ? key.trim() : '';
    setApiKey(normalizedKey);

    try {
      if (normalizedKey) {
        sessionStorage.setItem(STORAGE_KEY, normalizedKey);
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {
      console.warn('Unable to save the API key for this session:', error);
    }
  };

  const clearApiKey = () => {
    setApiKey('');

    try {
      sessionStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.warn('Unable to clear the API key:', error);
    }
  };

  const isValidApiKey = (key) => (
    typeof key === 'string'
    && key.startsWith('sk-')
    && key.length > 20
  );

  return (
    <ApiKeyContext.Provider
      value={{
        apiKey,
        updateApiKey,
        clearApiKey,
        isValidApiKey: isValidApiKey(apiKey),
        hasApiKey: Boolean(apiKey)
      }}
    >
      {children}
    </ApiKeyContext.Provider>
  );
};